import PropTypes from 'prop-types';
import { Autocomplete, IconButton, TextField, Typography } from '@mui/material';
import TextFormField from './IntegrationTextFormField';
import CheckboxFormField from './IntegrationCheckboxFormField';
import Row from './IntegrationFormRow';
import Iconify from '../../../../../reusable-components/iconify/Iconify';

CXMLOrderIntegration.propTypes = {
  value: PropTypes.object,
  sites: PropTypes.array,
  setValue: PropTypes.func,
};

export default function CXMLOrderIntegration({ value, setValue, sites }) {

  const setIdentitiesValue = (id, index, inputValue) =>
  {
    setValue(value => {    
      const identities = value.identities?.length > 0 ? value.identities : [{}];      
      identities[index][id] = inputValue;
      return { ...value, identities };
    });
  }

  return (
    <>
      <TextFormField
        header={'Order URL'}
        value={value.orderURL}
        onChange={(e) => setValue({ ...value, orderURL: e.target.value })}
      />
      <Row>
        <TextFormField
          header={'PS Identity'}
          value={value.psIdentity}
          onChange={(e) => setValue({ ...value, psIdentity: e.target.value })}
        />
        <TextFormField
          header={'Vendor Identity'}
          value={value.vendorIdentity}
          onChange={(e) => setValue({ ...value, vendorIdentity: e.target.value })}
        />
        <TextFormField
          header={'Sender Identity'}
          value={value.senderIdentity}
          onChange={(e) => setValue({ ...value, senderIdentity: e.target.value })}
        />
      </Row>
      <Row>
        <TextFormField
          header={'PS Identity Domain'}
          value={value.psIdentityDomain}
          onChange={(e) => setValue({ ...value, psIdentityDomain: e.target.value })}
        />
        <TextFormField
          header={'Vendor Identity Domain'}
          value={value.vendorIdentityDomain}
          onChange={(e) => setValue({ ...value, vendorIdentityDomain: e.target.value })}
        />
        <TextFormField
          header={'Sender Identity Domain'}
          value={value.senderIdentityDomain}
          onChange={(e) => setValue({ ...value, senderIdentityDomain: e.target.value })}
        />
      </Row>
      <Row>
        <TextFormField
          header={'Append To PS Identity'}
          value={value.appendToPSIdentity}
          onChange={(e) => setValue({ ...value, appendToPSIdentity: e.target.value })}
        />
        <TextFormField
          header={'Punchout Order PS Identity'}
          value={value.punchoutOrderPSIdentity}
          onChange={(e) => setValue({ ...value, punchoutOrderPSIdentity: e.target.value })}
        />
        <TextFormField
          header={'Punchout Order Vendor Identity'}
          value={value.punchoutOrderVendorIdentity}
          onChange={(e) => setValue({ ...value, punchoutOrderVendorIdentity: e.target.value })}
        />
      </Row>
      <Typography variant="subtitle1" sx={{ mt: 1 }}>
        Return Identites <IconButton onClick={() => { setValue({ ...value, identities: [...(value.identities || [{}]), {}] }) }}>
          <Iconify icon="mdi:plus-circle-outline" color="primary" width={28} height={28} />
        </IconButton>
      </Typography>          
      {(value.identities?.length > 0 ? value.identities : [{}]).map((identity, index) => <Row key={index}>
        <>
          {index === 0 && <Typography variant="subtitle1" sx={{ mt: 1 }}>Return PS Identity</Typography>}
          <TextField
            fullWidth
            size="small"
            value={identity.psIdentity ?? ""}
            onChange={(e) => setIdentitiesValue("psIdentity", index, e.target.value)}
            autoComplete="off"
            sx={{
              mt: 1,
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 },
              '& .MuiFormLabel-root ': { display: 'none' },
            }}
            />
        </>
        <>
          {index === 0 && <Typography variant="subtitle1" sx={{ mt: 1 }}>Return Vendor Identity</Typography>}
          <TextField
            fullWidth
            size="small"
            value={identity.vendorIdentity ?? ""}
            onChange={(e) => setIdentitiesValue("vendorIdentity", index, e.target.value)}
            autoComplete="off"
            sx={{
              mt: 1,
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 },
              '& .MuiFormLabel-root ': { display: 'none' },
            }}
            />
        </>
        <>
          {index === 0 && <Typography variant="subtitle1" sx={{ mt: 1 }}>Site</Typography>}
          <Autocomplete
            fullWidth
            size="small"
            value={sites.find(site => site.value === identity.siteId) || null}
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            onChange={(event, newValue) => {
              setIdentitiesValue("siteId", index, newValue?.value ?? 0);
            }}
            renderInput={(params) => <TextField {...params} label="Search or select" autoComplete="off"/>}
            sx={{
              mt: 0.5,
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 },
              '& .MuiFormLabel-root ': { display: 'none' },
            }}
            options={sites}
          />        
        </>
      </Row>)}
      <Row>
        <CheckboxFormField
          label={'Ordering Disabled'}
          checked={value.orderingDisabled ?? false}
          onChange={(e) => setValue({ ...value, orderingDisabled: e.target.checked })}
        />
        <CheckboxFormField
          label={'Custom Order Date'}
          checked={value.customOrderDate ?? false}
          onChange={(e) => setValue({ ...value, customOrderDate: e.target.checked })}
        />
        <CheckboxFormField
          label={'Allows Top Level Comments'}
          checked={value.allowsTopLevelComments ?? false}
          onChange={(e) => setValue({ ...value, allowsTopLevelComments: e.target.checked })}
        />
      </Row>
      <Row>
        <CheckboxFormField
          label={'Only Use Punchout Items'}
          checked={value.onlyUsePunchoutItems ?? false}
          onChange={(e) => setValue({ ...value, onlyUsePunchoutItems: e.target.checked })}
        />
        <CheckboxFormField
          label={'Vendor Returns Account As Identity'}
          checked={value.vendorReturnsAccountAsIdentity ?? false}
          onChange={(e) => setValue({ ...value, vendorReturnsAccountAsIdentity: e.target.checked })}
        />
        <CheckboxFormField
          label={'Use Account As PS Identity'}
          checked={value.useAccountAsPSIdentity ?? false}
          onChange={(e) => setValue({ ...value, useAccountAsPSIdentity: e.target.checked })}
        />
      </Row>
      <CheckboxFormField
        label={'Allows Requested Delivery Date'}
        checked={value.allowsRequestedDeliveryDate ?? false}
        onChange={(e) => setValue({ ...value, allowsRequestedDeliveryDate: e.target.checked })}
      />
    </>
  );
}
